/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_LedeInputs */

const tr_landing_hero_lede = /** @type {(inputs: Landing_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm pazaryerleriniz tek kokpitte. Döviz oynadığında yeni fiyatlarınız hesaplanır; Telegram'dan tek tuşla onaylarsınız ya da kuralı otomatik uygulatırsınız. Genius AI ajanları müşteri sorularına yanıt önerir.`)
};

const en_landing_hero_lede = /** @type {(inputs: Landing_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All your marketplaces in one cockpit. When exchange rates move, your new prices are calculated; you approve them with a single tap in Telegram or let the rule apply them automatically. Genius AI agents suggest replies to customer questions.`)
};

const de_landing_hero_lede = /** @type {(inputs: Landing_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Ihre Marktplätze in einem Cockpit. Wenn der Wechselkurs schwankt, werden Ihre neuen Preise berechnet; Sie geben sie per Telegram mit einem Klick frei oder lassen die Regel sie automatisch anwenden. Genius AI Agenten schlagen Antworten auf Kundenfragen vor.`)
};

const ru_landing_hero_lede = /** @type {(inputs: Landing_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все ваши маркетплейсы в одном центре управления. При колебаниях валютных курсов рассчитываются новые цены; вы подтверждаете их одним нажатием в Telegram или поручаете правилу применять их автоматически. Агенты Genius AI предлагают ответы на вопросы покупателей.`)
};

/**
* | output |
* | --- |
* | "All your marketplaces in one cockpit. When exchange rates move, your new prices are calculated; you approve them with a single tap in Telegram or let the rul..." |
*
* @param {Landing_Hero_LedeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_hero_lede = /** @type {((inputs?: Landing_Hero_LedeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_LedeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_hero_lede(inputs)
	if (locale === "de") return de_landing_hero_lede(inputs)
	if (locale === "ru") return ru_landing_hero_lede(inputs)
	return tr_landing_hero_lede(inputs)
});